import React, { useEffect } from 'react';
import { CircularProgress, IconButton, makeStyles, Paper, Typography } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../actions';
import { StatusDpinDairAPI } from '../../../API/status_dpin_dair';
import { unoTheme, useColors } from '../../../assets/styles/unoTheme';
import MyTable from '../../utils/MyTable';
import { applyMaskAmount, applyMaskAmountComdinheiro, formatDataToPieChart, getMonthName, greenOrRed } from '../../utils/utils';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MyToggleSegregationButton from "../../utils/MyToggleSegregationButton";
import { useMemo } from 'react';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',

    '& .table-div': {
      height: 'calc(100vh - 141px) !important',
      width: "100%",
      maxWidth: "100%",
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    backgroundColor: unoTheme.hoverTable,
  },
  leftHeader: {

    display: 'flex',
    flexDirection: 'column',
    //alignItems: 'center',
  },
  fundLabel: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1C2228'
  },
  accountLabel: {
    fontSize: '14px',
    color: unoTheme.secondaryColor,
    display: "flex",
    alignItems: 'center',
    gap: "16px"
  },
  spacingLeft2: {
    marginLeft: theme.spacing(2)
  },
  green: {
    color: unoTheme.greenMoney,
  },

  addCommentLabel: {
    cursor: "pointer",
    color: unoTheme.defaultTextColor,

    '&:hover': {
      color: unoTheme.mainColor,
    }
  },
  rightDivBackdrop: {
    zIndex: 3,
    backgroundColor: 'white',
    position: 'absolute',
    opacity: 0.85,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    color: unoTheme.mainColor,
    alignItems: 'center',
    justifyContent: 'center',

    '& .progress': {
      color: unoTheme.mainColor
    }
  },

}));


export default function AssetsByPeriodInReturns({ content }) {
  const dispatch = useDispatch();

  const {
    data: { period, assets }
  } = content;

  console.log("Period: ", period);
  console.log("Assets: ", assets);

  const classes = useStyles();

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const clientOn = useSelector(state => state.clientOn)

  const [formats, setFormats] = React.useState(() => null);

  const handleFormat = (event, newFormats) => {

    console.log("NEW FORMAT: ", newFormats)

    switch (newFormats) {

      case 0:
        break;
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;

    }

    console.log("newFormats: ", newFormats);

    setFormats(newFormats);
  };

  const filteredAssets = useMemo(() => {

    if (!assets) return [];
    return [...assets.funds, ...assets.titles].filter(el => formats == null || el.accountRegimeId === formats);
  }, [assets, formats])

  return (
    <div className={classes.root}>

      <Paper style={{ marginBottom: '4px' }}>
        <div className={classes.header}>
          <div className={classes.leftHeader}>
            <div>
              <Typography
                align={'left'}
                className={classes.fundLabel}>
                {`Ativos no período`}
              </Typography>
              <Typography
                align={'left'}
                className={classes.accountLabel}>

                <span>Período:
                  <Typography component="strong" style={{ color: unoTheme.mainColor, marginLeft: "8px" }}>{period}</Typography>
                </span>

                <span>Nº de ativos:
                  <Typography component="strong" style={{ color: unoTheme.mainColor, marginLeft: "8px" }}>
                    {
                      filteredAssets ?
                        filteredAssets.length : ""
                    }
                  </Typography>
                </span>

                <span>Saldo total:
                  <Typography component="strong" style={{ color: unoTheme.greenMoney, marginLeft: "8px" }}>
                    {
                      filteredAssets ?
                        applyMaskAmount(filteredAssets.reduce(
                          (previous, current) => previous + current.balanceNow,
                          0
                        ), true) : ""
                    }
                  </Typography>
                </span>

              </Typography>
            </div>
          </div>

          <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
            <CloseIcon />
          </IconButton>

        </div>
      </Paper>

      <MyToggleSegregationButton
        value={formats}
        handleValue={handleFormat}
        // disabled={innerLoad.show && !innerLoad.emptyMessage}
        clientOn={clientOn}
      />
      <div className="table-div">
        <MyTable
          stickyHeader
          nofixed={true}
          size="small">
          <colgroup>
            <col width="45%" />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell align="left">Ativo</TableCell>
              <TableCell align="center">CNPJ</TableCell>
              <TableCell align="center">Conta</TableCell>
              <TableCell align="right">Saldo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredAssets ?
              filteredAssets.map((obj, index) => (
                <TableRow key={'assets-in-returns-' + index}>
                  <TableCell align="left">{obj.fundName}</TableCell>
                  <TableCell align="center">{obj.cnpj}</TableCell>
                  <TableCell align="center">{obj.numberAccount + (obj.agency ? " / " + obj.agency : "")}</TableCell>
                  <TableCell align="right" style={{ color: greenOrRed(obj.balanceNow) }}>{applyMaskAmount(obj.balanceNow, true)}</TableCell>
                </TableRow>
              ))
              : null
            }
          </TableBody>
        </MyTable>
      </div>

      {
        openBackdrop ?
          <div className={classes.rightDivBackdrop}>
            <CircularProgress className={'progress'} />
            <Typography variant={'body1'} style={{ marginTop: '16px' }}>
              Carregando contadores...
            </Typography>

          </div> : null
      }
    </div>
  )
}
